import { render } from "./CollectionItemsCommentsWidget.vue.js?vue&type=template&id=c55bf1a2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsCommentsWidget.vue?vue&type=template&id=c55bf1a2"
import script from "./CollectionItemsCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsCommentsWidget.vue?vue&type=script&lang=js"
export * from "./CollectionItemsCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsCommentsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/collection-items-page/CollectionItemsCommentsWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c55bf1a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c55bf1a2', __exports__)) {
    api.reload('c55bf1a2', __exports__)
  }
  
  module.hot.accept("./CollectionItemsCommentsWidget.vue.js?vue&type=template&id=c55bf1a2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsCommentsWidget.vue?vue&type=template&id=c55bf1a2", () => {
    api.rerender('c55bf1a2', render)
  })

}


export default __exports__